/* Cannabis Pharmacy home page — vanilla JS (no jQuery, no theme dependencies) */
(function () {
  'use strict';

  /* ---------- Cookie helpers (work on Shopify subdomains too) ---------- */
  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  /* ---------- Age gate ---------- */
  var gate = document.getElementById('ageGate');
  if (gate) {
    if (getCookie('cp_age_ok') !== '1') {
      gate.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    gate.addEventListener('click', function (e) {
      if (e.target.closest('[data-age-yes]')) {
        setCookie('cp_age_ok', '1', 30);
        gate.hidden = true;
        document.body.style.overflow = '';
      }
      if (e.target.closest('[data-age-no]')) {
        window.location.href = 'https://www.google.com';
      }
    });
  }

  /* ---------- Star ratings ---------- */
  document.querySelectorAll('.cp-rating').forEach(function (wrap) {
    var value = parseFloat(wrap.getAttribute('data-rating') || '0');
    wrap.querySelectorAll('.cp-stars i').forEach(function (star, i) {
      if (value >= i + 1) star.classList.add('is-on');
      else if (value > i) star.classList.add('is-half');
    });
  });

  /* ---------- Hero slider ---------- */
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var track = slider.querySelector('.cp-slider__track');
    var slides = track.children;
    var dotsBox = slider.querySelector('.cp-slider__dots');
    var index = 0;
    var timer = null;
    var delay = parseInt(slider.getAttribute('data-autoplay') || '0', 10);

    for (var i = 0; i < slides.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      (function (n) { dot.addEventListener('click', function () { go(n); restart(); }); })(i);
      dotsBox.appendChild(dot);
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dotsBox.querySelectorAll('button').forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }
    function restart() {
      if (!delay) return;
      clearInterval(timer);
      timer = setInterval(function () { go(index + 1); }, delay);
    }

    slider.querySelector('.cp-slider__arrow--prev').addEventListener('click', function () { go(index - 1); restart(); });
    slider.querySelector('.cp-slider__arrow--next').addEventListener('click', function () { go(index + 1); restart(); });
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', restart);

    go(0);
    restart();
  });

  /* ---------- Product / review carousels ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('.cp-carousel__track');
    var dotsBox = car.querySelector('.cp-carousel__dots');
    var prev = car.querySelector('.cp-carousel__arrow--prev');
    var next = car.querySelector('.cp-carousel__arrow--next');

    function pages() {
      return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
    }
    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function buildDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = '';
      var total = pages();
      if (total < 2) return;
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Page ' + (i + 1));
        (function (n) {
          b.addEventListener('click', function () {
            track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
          });
        })(i);
        dotsBox.appendChild(b);
      }
      sync();
    }
    function sync() {
      if (!dotsBox) return;
      var c = current();
      dotsBox.querySelectorAll('button').forEach(function (d, i) {
        d.classList.toggle('is-active', i === c);
      });
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();
  });

  /* ---------- Mobile menu toggle ---------- */
  var catBtn = document.querySelector('.cp-catbtn');
  var nav = document.querySelector('.cp-nav');
  if (catBtn && nav) {
    catBtn.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    var value = parseInt(input.value, 10) || 1;
    value = btn.getAttribute('data-qty') === '+' ? value + 1 : Math.max(1, value - 1);
    input.value = value;
  });
})();

/* ── Article share buttons ─────────────────────────────────────────────── */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cp-post__share');
  if (!btn) return;
  e.preventDefault();
  var url   = btn.dataset.shareUrl   || window.location.href;
  var title = btn.dataset.shareTitle || document.title;
  var text  = btn.dataset.shareText  || '';
  if (navigator.share) {
    navigator.share({ title: title, text: text, url: url }).catch(function(){});
  } else {
    // Fallback: copy URL to clipboard
    navigator.clipboard.writeText(url).then(function() {
      var orig = btn.innerHTML;
      btn.textContent = 'Copied!';
      setTimeout(function() { btn.innerHTML = orig; }, 2000);
    }).catch(function() {
      window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title), '_blank');
    });
  }
});

/* ── Category Rail + All Categories Menu ───────────────────────────────────── */
(function () {
  var wrap = document.querySelector('.cp-catmenu');
  if (!wrap) return;

  var btn      = wrap.querySelector('.cp-catbtn');
  var panel    = wrap.querySelector('.cp-catmenu__panel');
  var backdrop = document.getElementById('cpCatBackdrop') || (function(){
    var d = document.createElement('div');
    d.className = 'cp-catmenu__backdrop';
    d.id = 'cpCatBackdrop';
    document.body.appendChild(d);
    return d;
  }());

  function isTouchLayout() {
    return window.matchMedia('(max-width:767px)').matches ||
           !window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  }

  function closeMenu() {
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    backdrop.classList.remove('is-on');
    wrap.querySelectorAll('.is-open').forEach(function(n){ n.classList.remove('is-open'); });
  }

  function openMenu() {
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    if (isTouchLayout()) backdrop.classList.add('is-on');
  }

  btn.addEventListener('click', function(e) {
    e.stopPropagation();
    panel.hidden ? openMenu() : closeMenu();
  });

  /* Rail burger also toggles the same panel */
  var railBtn = document.querySelector('.cp-rail__toggle');
  if (railBtn) {
    railBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      panel.hidden ? openMenu() : closeMenu();
      railBtn.setAttribute('aria-expanded', String(!panel.hidden));
    });
  }

  /* Hover open on desktop */
  var hoverTimer;
  wrap.addEventListener('mouseenter', function() {
    if (isTouchLayout()) return;
    clearTimeout(hoverTimer);
    openMenu();
  });
  wrap.addEventListener('mouseleave', function() {
    if (isTouchLayout()) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(closeMenu, 220);
  });

  backdrop.addEventListener('click', closeMenu);
  document.addEventListener('click', function(e) {
    if (!panel.hidden && !wrap.contains(e.target)) closeMenu();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* Mobile accordion */
  panel.addEventListener('click', function(e) {
    if (!isTouchLayout()) return;
    var link = e.target.closest('.cp-catmenu__link');
    if (!link) return;
    var parent = link.parentNode;
    if (!parent.classList.contains('cp-catmenu__item--parent') &&
        !parent.classList.contains('cp-catmenu__subitem--parent')) return;
    e.preventDefault();
    var siblings = parent.parentNode.children;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== parent) siblings[i].classList.remove('is-open');
    }
    parent.classList.toggle('is-open');
  });

  window.addEventListener('resize', function() {
    if (!panel.hidden) closeMenu();
  });
})();

/* ── Collection & Brand Pages ─────────────────────────────────────────────── */
(function () {

  /* 1 ▸ View-switch (grid-1 / grid-3 / grid-4) */
  document.querySelectorAll('.cp-viewswitch button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = document.getElementById('cp-product-grid') || document.getElementById('cp-brand-grid');
      if (!grid) return;
      var n = parseInt(this.getAttribute('data-grid') || '3', 10);
      grid.classList.remove('cp-grid--1', 'cp-grid--3', 'cp-grid--4');
      grid.classList.add('cp-grid--' + n);
      this.closest('.cp-viewswitch').querySelectorAll('button').forEach(function (b) {
        b.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* 2 ▸ Sidebar category toggle (accordion) */
  document.querySelectorAll('.cp-catlist__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var sub = this.nextElementSibling;
      if (!sub) return;
      this.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        sub.hidden = true;
      } else {
        sub.hidden = false;
      }
    });
  });

  /* 3 ▸ Price filter — label update + fill bar */
  function cpUpdatePrice() {
    var minEl = document.getElementById('cpPriceMin');
    var maxEl = document.getElementById('cpPriceMax');
    var labelEl = document.getElementById('cpPriceLabel');
    var fillEl = document.getElementById('cpPriceFill');
    var form   = document.getElementById('cp-price-form');
    if (!minEl || !maxEl) return;
    var min = parseFloat(minEl.value) || 0;
    var max = parseFloat(maxEl.value) || 500;
    var rangeMax = parseFloat(minEl.getAttribute('max')) || 500;
    if (max < min) { max = min; maxEl.value = min; }
    if (labelEl) labelEl.innerHTML = 'Price: <strong>$' + min + ' &mdash; $' + max + '</strong>';
    if (fillEl) {
      var leftPct  = (min / rangeMax * 100).toFixed(1) + '%';
      var rightPct = ((1 - max / rangeMax) * 100).toFixed(1) + '%';
      fillEl.style.left  = leftPct;
      fillEl.style.right = rightPct;
    }
  }
  window.cpUpdatePrice = cpUpdatePrice;
  window.cpUpdatePriceLabel = cpUpdatePrice; // backwards compat

  /* Init price fill on page load */
  document.addEventListener('DOMContentLoaded', function() {
    cpUpdatePrice();
  });

  /* 4 ▸ Star painter — reads data-rating on .cp-rating and fills .cp-stars */
  document.querySelectorAll('.cp-rating').forEach(function (el) {
    var rating = parseFloat(el.getAttribute('data-rating')) || 0;
    var stars = el.querySelectorAll('.cp-stars i');
    stars.forEach(function (star, idx) {
      var fill = rating - idx;
      if (fill >= 1) star.classList.add('lit');
      else if (fill >= 0.5) star.classList.add('half');
    });
  });

})();
 
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.cp-seo-wrap').forEach(function (wrap) {

    var block = wrap.querySelector('.cp-seo--collapsible');

    if (!block) return;

    var collapsedH = 120;

    // Create the button automatically
    var btn = document.createElement('button');

    btn.type = 'button';
    btn.className = 'cp-seo__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read More';

    // Add button after the SEO content
    wrap.appendChild(btn);

    function initReadMore() {

      // Temporarily open the block to get its full height
      var originalMaxHeight = block.style.maxHeight;

      block.style.maxHeight = 'none';

      var fullHeight = block.scrollHeight;

      // Restore original inline height
      block.style.maxHeight = originalMaxHeight;

      // Only show button if content is taller than 120px
      if (fullHeight > collapsedH + 10) {

        btn.hidden = false;

        block.classList.remove('is-open');

      } else {

        // Content is short, so show everything and hide button
        block.classList.add('is-open');
        btn.hidden = true;

      }
    }

    btn.addEventListener('click', function () {

      var open = block.classList.toggle('is-open');

      btn.setAttribute('aria-expanded', open ? 'true' : 'false');

      btn.textContent = open ? 'Read Less' : 'Read More';

    });

    // Wait until Shopify page resources are loaded
    if (document.readyState === 'complete') {
      initReadMore();
    } else {
      window.addEventListener('load', initReadMore);
    }

  });

});

/* ── Gallery ─────────────────────────────────────────────────────────────── */
(function() {
  var mainImg = document.getElementById('cpGalleryMain');
  if (!mainImg) return;

  // Thumbnails
  document.querySelectorAll('.cp-gallery__thumb').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.cp-gallery__thumb').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var full = btn.dataset.full;
      if (full) mainImg.src = full;
    });
  });

  // Zoom (lightbox - open image in new tab for now)
  var zoomBtn = document.querySelector('.cp-gallery__zoom');
  if (zoomBtn) {
    zoomBtn.addEventListener('click', function() {
      window.open(mainImg.src, '_blank');
    });
  }
})();

/* ── Tabs ─────────────────────────────────────────────────────────────────── */
(function() {
  document.querySelectorAll('[data-tabs]').forEach(function(tabs) {
    tabs.querySelectorAll('.cp-tabs__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;

        // Deactivate all
        tabs.querySelectorAll('.cp-tabs__btn').forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        tabs.querySelectorAll('.cp-tabs__panel').forEach(function(p) {
          p.classList.remove('is-active');
          p.hidden = true;
        });

        // Activate clicked
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        panel.classList.add('is-active');
        panel.hidden = false;
      });
    });
  });
})();

/* ── Qty steppers ─────────────────────────────────────────────────────────── */
(function() {
  document.querySelectorAll('.cp-qty').forEach(function(wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var v = parseInt(input.value, 10) || 1;
        if (btn.dataset.qty === '+') input.value = v + 1;
        else if (btn.dataset.qty === '-' && v > 1) input.value = v - 1;
      });
    });
  });
})();

/* ── Stars painter ────────────────────────────────────────────────────────── */
(function() {
  document.querySelectorAll('.cp-rating').forEach(function(el) {
    var rating = parseFloat(el.dataset.rating) || 0;
    var stars = el.querySelectorAll('.cp-stars i');
    stars.forEach(function(star, idx) {
      var fill = rating - idx;
      if (fill >= 1) star.classList.add('lit');
      else if (fill >= 0.5) star.classList.add('half');
    });
  });
})();
